import { render, staticRenderFns } from "./Riclist.vue?vue&type=template&id=2425393c&"
import script from "./Riclist.vue?vue&type=script&lang=js&"
export * from "./Riclist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports